// extracted by mini-css-extract-plugin
module.exports =  {"back":"Evr0UNoxs2JfEpELRGDN","button":"pyNE67fNl4q7DcEoZjQf","reachout":"gxyWdW6qGqU6mjfuaDXP","resend":"XvaIl1mZgm1wJ0u34f4H"};